import './instrument';
import ReactDOM from 'react-dom/client';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import App from './App';
import './index.css';
import keycloak from './keycloak';
import { useAuthStore } from './store/authStore';
import { reactErrorHandler } from '@sentry/react';

let savedTokens: { token?: string; refreshToken?: string; idToken?: string } | null = null;
try {
  const raw = typeof window !== 'undefined' ? sessionStorage.getItem('kibo_auth_tokens') : null;
  if (raw) savedTokens = JSON.parse(raw);
} catch {}

const initOptions = {
  onLoad: 'check-sso' as const,
  pkceMethod: 'S256' as const,
  checkLoginIframe: false,
  silentCheckSsoFallback: false,
  silentCheckSsoRedirectUri:
    typeof window !== 'undefined'
      ? window.location.origin + '/silent-check-sso.html'
      : undefined,
  ...(savedTokens?.token
    ? {
        token: savedTokens.token,
        refreshToken: savedTokens.refreshToken,
        idToken: savedTokens.idToken,
      }
    : {}),
};

const syncAuthStore = () => {
  void useAuthStore.getState().initialize();
};

ReactDOM.createRoot(document.getElementById('root')!, {
  onUncaughtError: reactErrorHandler(),
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
}).render(
  <ReactKeycloakProvider
    authClient={keycloak}
    autoRefreshToken
    initOptions={initOptions}
    onEvent={(_event, error) => {
      if (error) {
        const errStr = String((error as any)?.message || error);
        if (
          !errStr.includes('initialized once') &&
          !errStr.includes('already initialized') &&
          !errStr.includes('3rd party check iframe')
        ) {
          console.error('Keycloak provider event error:', error);
        }
      }
      syncAuthStore();
    }}
    onTokens={(tokens) => {
      if (tokens?.token) {
        try {
          sessionStorage.setItem(
            'kibo_auth_tokens',
            JSON.stringify({
              token: tokens.token,
              refreshToken: tokens.refreshToken,
              idToken: tokens.idToken,
            }),
          );
        } catch {}
      }
      syncAuthStore();
    }}
  >
    <App />
  </ReactKeycloakProvider>,
);

